import {BaseModel} from "./base-model";
import {Organization} from "./organization";
import {Device} from "./device";

export class Equipment extends BaseModel {
  latitude: number;
  longitude: number;
  isActive: boolean;
  isDeleted: boolean;
  devices: Partial<Device>[];
  organization: Partial<Organization>;
  lastBatteryEventAt: Date;
  lastBatteryEventVoltage: number;
  lastBatteryEventWarned: boolean;
  lastBatteryEventAlerted: boolean;
  linkedAt: Date;
  createdAt: Date;
}
